import { gql } from "gql";

export const GET_AVATAR_LINK = gql(/* GraphQL */ `
  query GetAvatarLink($id: ID!) {
    getPersonById(id: $id) {
      __typename
      id
      avatar {
        ... on FileDto {
          downloadLink
        }
        ... on Hidden {
          ...Hidden
        }
      }
    }
  }
`);
